import { CircularProgress } from '@mui/material';

import { SLoaderWrapper } from './style';

const Loader = () => {
  return <SLoaderWrapper><CircularProgress /></SLoaderWrapper>;
};

export default Loader;
